/**
 * Uzbek strings of the settings lists, the rate panel of the money dialogs, expense storno and
 * the offer page's beach line. Spread into `uz`, so a key here is a `TranslationKey` like any other.
 */
export const uzSettingsFinance = {
  "tasks.accepted": "Qabul qilingan",
  "priceWatch.title": "Kuzatuvlar",
  "priceWatch.watch": "Narxni kuzatish",
  "priceWatch.destinations": "Yo'nalishlar",
  "priceWatch.destinationsHint": "Yaqin 14 kundagi eng arzon yangi taklif (2 kishiga) oldingi natijadan tushsa, xabar beramiz.",
  "priceWatch.destination": "Yo'nalish",
  "priceWatch.noDestinations": "Agentlik yo'nalishlari hali tanlanmagan: Sozlamalar, Yo'nalishlar.",
  "priceWatch.currency": "Valyuta",
  "priceWatch.target": "Maqsadli narx (ixtiyoriy)",
  "priceWatch.start": "Kuzatish",
  "priceWatch.started": "Kuzatuv yoqildi",
  "priceWatch.failed": "Kuzatuvni yoqib bo'lmadi",
  "priceWatch.noResult": "hali natija yo'q",
  "priceWatch.lastResult": "oxirgi natija: {price}",
  "priceWatch.forClient": "Mijoz uchun",
  "priceWatch.tellClient": "Mijozga ham xabar berilsin (rozilik bo'lsa)",
  "priceWatch.noConsent": "Kuzatuv yoqildi, lekin mijozdan rozilik yo'q: xabar faqat sizga keladi.",
  "settings.nav.finance": "Moliya",
  "settings.nav.billing": "Tarif va kreditlar",
  "settings.finance.title": "Moliya sozlamalari",
  "settings.edit": "Tahrirlash",
  "settings.toggleFailed": "O'zgartirib bo'lmadi",

  "settings.branches.hours": "Ish vaqti",
  "settings.branches.aroundTheClock": "Kecha-kunduz",
  "settings.branches.hoursStart": "Boshlanishi",
  "settings.branches.hoursEnd": "Tugashi",
  "settings.branches.hoursHint": "Ikkalasi bo'sh bo'lsa, filial kecha-kunduz ishlaydi.",
  "settings.branches.week": "Hafta kunlari",
  "settings.branches.weekHint": "Vaqti bo'sh kun yuqoridagi umumiy ish vaqti bilan ishlaydi.",
  "settings.branches.dayOff": "Dam olish",
  "settings.branches.ownDays": "alohida kunlar bor",
  "settings.branches.day.mon": "Dushanba",
  "settings.branches.day.tue": "Seshanba",
  "settings.branches.day.wed": "Chorshanba",
  "settings.branches.day.thu": "Payshanba",
  "settings.branches.day.fri": "Juma",
  "settings.branches.day.sat": "Shanba",
  "settings.branches.day.sun": "Yakshanba",
  "settings.branches.hoursHalf": "Ikkala vaqtni ham kiriting yoki ikkalasini ham bo'sh qoldiring.",

  "settings.lossReasons.title": "Yo'qotish sabablari",
  "settings.lossReasons.add": "+ Sabab qo'shish",
  "settings.lossReasons.empty": "Yo'qotish sabablari yo'q",
  "settings.expenseCategories.title": "Chiqim kategoriyalari",
  "settings.expenseCategories.add": "+ Kategoriya qo'shish",
  "settings.expenseCategories.empty": "Chiqim kategoriyalari yo'q",
  "settings.expenseCategories.requiresVendor": "Ta'minotchi va bitim talab qilinadi",
  "settings.list.name": "Nomi",
  "settings.list.yes": "Ha",
  "settings.list.no": "Yo'q",

  "finance.rate.cbu": "Kurs: CBU kursi",
  "finance.rate.crossing": "Kurs: bronda qotirilgan provayder kursi. Bronda kurs bo'lmasa, qo'lda kiritiladi.",
  "finance.rate.manualLabel": "Kurs: 1 USD necha so'm",

  "finance.expense.status": "Holat",
  "finance.expense.stornoStatus": "STORNO",
  "finance.expense.stornoAction": "Storno",
  "finance.expense.stornoTitle": "Chiqimni storno qilish",
  "finance.expense.stornoHint": "Chiqim o'chirilmaydi: teskari yozuv qo'shiladi va ikkalasi ham tarixda qoladi.",
  "finance.expense.stornoReason": "Sabab",
  "finance.expense.stornoConfirm": "Storno qilish",
  "finance.expense.stornoClose": "Yopish",
  "finance.expense.stornoFailed": "Storno qilib bo'lmadi. Qayta urinib ko'ring.",

  "offer.beachDistance": "Plyajgacha {meters} m",
} as const;
